export {
  default as ToggleSwitch,
  type ToggleSwitchProps,
} from './ToggleSwitch';
